import useFilterModal from "./plpUseFilterModal";

export default useFilterModal;
